[
  ["B1", "B1", "Bay Ridge - Manhattan Beach", "00AEEF"],
  ["B2", "B2", "Kings Hwy Station - Kings Plaza", "006CB7"],
  ["B3", "B3", "Bensonhurst - Bergen Beach", "EE352E"],
  ["B4", "B4", "Bay Ridge - Sheepshead Bay", "6CBE45"],
  ["B6", "B6", "Bath Beach - East New York", "EE352E"],
  ["B7", "B7", "Midwood - Bedford-Stuyvesant", "EE352E"],
  ["B8", "B8", "Dyker Heights - East Flatbush", "FAA61A"],
  ["B9", "B9", "Bay Ridge - Kings Plaza", "EE352E"],
  ["B11", "B11", "Sunset Park - Midwood", "006CB7"],
  ["B12", "B12", "Lefferts Gardens - East New York", "6CBE45"],
  ["B13", "B13", "Spring Creek - Wyckoff Hospital", "FAA61A"],
  ["B14", "B14", "Spring Creek - Crown Heights", "00AEEF"],
  ["B15", "B15", "Bedford Stuyvesant - JFK AirTrain", "B933AD"],
  ["B16", "B16", "Bay Ridge - Lefferts Gardens", "FAA61A"],
  ["B17", "B17", "Canarsie - Crown Heights", "B933AD"],
  ["B20", "B20", "Ridgewood - Spring Creek", "6CBE45"],
  ["B24", "B24", "Williamsburg - Greenpoint", "FAA61A"],
  ["B25", "B25", "Dwntn Bklyn & DUMBO - Broadway Junction", "6CBE45"],
  ["B26", "B26", "Downtown Brooklyn - Ridgewood", "006CB7"],
  ["B31", "B31", "Gerritsen Beach - Kings Hwy Station", "FAA61A"],
  ["B32", "B32", "Williamsburg - Long Island City", "006CB7"],
  ["B35", "B35", "Brownsville - Sunset Park", "EE352E"],
  ["B36", "B36", "Sheepshead Bay - Coney Island", "FAA61A"],
  ["B37", "B37", "Downtown Brooklyn - Bay Ridge", "B933AD"],
  ["B38", "B38", "Ridgewood - Downtown Brooklyn", "00AEEF"],
  ["B39", "B39", "Williamsburg Bridge Plaza - Lower East Side", "00AEEF"],
  ["B41", "B41", "Kings Plaza - Downtown Brooklyn", "006CB7"],
  ["B42", "B42", "Canarsie Pier - Rockaway Parkway Station", "006CB7"],
  ["B43", "B43", "Greenpoint - Lefferts Gardens", "EE352E"],
  ["B44", "B44", "Sheepshead Bay - Williamsburg", "B933AD"],
  ["B44+", "B44-SBS", "Sheepshead Bay - Williamsburg", "B933AD"],
  ["B45", "B45", "Downtown Brooklyn - Crown Heights", "EE352E"],
  ["B46", "B46", "Kings Plaza - Williamsburg", "6CBE45"],
  ["B46+", "B46-SBS", "Kings Plaza - Williamsburg", "6CBE45"],
  ["B47", "B47", "Kings Plaza - Bedford-Stuyvesant", "FAA61A"],
  ["B48", "B48", "Lefferts Gardens - Greenpoint", "6CBE45"],
  ["B49", "B49", "Manhattan Beach - Bedford-Stuyvesant", "EE352E"],
  ["B52", "B52", "Downtown Brooklyn - Ridgewood", "EE352E"],
  ["B54", "B54", "Downtown Brooklyn - Ridgewood", "6CBE45"],
  ["B57", "B57", "Gowanus - Maspeth", "EE352E"],
  ["B60", "B60", "Williamsburg - Canarsie", "B933AD"],
  ["B61", "B61", "Park Slope - Downtown Brooklyn", "6CBE45"],
  ["B62", "B62", "Astoria - Downtown Brooklyn", "00AEEF"],
  ["B63", "B63", "Bay Ridge - Cobble Hill", "006CB7"],
  ["B64", "B64", "Bay Ridge - Coney Island", "6CBE45"],
  ["B65", "B65", "Downtown Brooklyn - Crown Heights", "00AEEF"],
  ["B67", "B67", "Brooklyn Navy Yard - Kensington", "EE352E"],
  ["B68", "B68", "Coney Island - Windsor Terrace", "EE352E"],
  ["B69", "B69", "Downtown Brooklyn - Kensington", "006CB7"],
  ["B70", "B70", "Dyker Heights - Sunset Park", "B933AD"],
  ["B74", "B74", "Sea Gate - Stillwell Av", "EE352E"],
  ["B82", "B82", "Coney Island - Spring Creek Towers", "6CBE45"],
  ["B82+", "B82-SBS", "Coney Island -spring Creek Towers", "6CBE45"],
  ["B83", "B83", "Spring Creek - Broadway Junction", "EE352E"],
  ["B84", "B84", "Spring Creek-New Lots", "006CB7"],
  ["B100", "B100", "Mill Basin - Midwood", "B933AD"],
  ["B103", "B103", "Canarsie - Downtown Brooklyn Ltd", "FAA61A"],
  ["BM1", "BM1", "Mill Basin - Downtown/Midtown", "00933C"],
  ["BM2", "BM2", "Canarsie/Spring Creek - Downtown/Midtown", "00933C"],
  ["BM3", "BM3", "Sheepshead Bay - Downtown/Midtown", "00933C"],
  ["BM4", "BM4", "Gerritsen Beach - Downtown/Midtown", "00933C"],
  ["BM5", "BM5", "Spring Creek - Midtown", "00933C"],
  ["BX1", "Bx1", "Riverdale - Mott Haven", "00AEEF"],
  ["BX2", "Bx2", "Kingsbridge Heights - Mott Haven", "FAA61A"],
  ["BX3", "Bx3", "Riverdale - George Washington Bridge", "EE352E"],
  ["BX4", "Bx4", "Westchester Sq - The Hub", "FAA61A"],
  ["BX4A", "Bx4A", "Westchester Sq - Gladstone Sq", "FAA61A"],
  ["BX5", "Bx5", "Pelham Bay - Gladstone Sq", "EE352E"],
  ["BX6", "Bx6", "Hunts Point - Riverside Dr", "EE352E"],
  ["BX6+", "Bx6-SBS", "Hunts Point - Riverside Dr", "EE352E"],
  ["BX7", "Bx7", "Riverdale - Washington Heights", "EE352E"],
  ["BX8", "Bx8", "Williamsbridge - Locust Point", "FAA61A"],
  ["BX9", "Bx9", "Riverdale - West Farms Sq", "FAA61A"],
  ["BX10", "Bx10", "Riverdale - Norwood", "006CB7"],
  ["BX11", "Bx11", "George Washington Bridge - Parkchester", "FAA61A"],
  ["BX12", "Bx12", "Pelham Bay - Inwood", "006CB7"],
  ["BX12+", "Bx12-SBS", "Bay Plaza - Inwood", "006CB7"],
  ["BX13", "Bx13", "George Washington Bridge - Bronx Terminal Market", "006CB7"],
  ["BX15", "Bx15", "Fordham Plaza - The Hub", "FAA61A"],
  ["BX16", "Bx16", "Pelham - Norwood", "00AEEF"],
  ["BX17", "Bx17", "Fordham Plaza - Port Morris", "006CB7"],
  ["BX18A", "Bx18A", "Morris Heights/High Bridge Circulator", "6CBE45"],
  ["BX18B", "Bx18B", "Morris Heights/High Bridge Circulator", "6CBE45"],
  ["BX19", "Bx19", "NY Botanical Garden - Riverbank Park", "B933AD"],
  ["BX20", "Bx20", "Riverdale - Inwood", "00AEEF"],
  ["BX21", "Bx21", "Westchester Sq - Mott Haven", "6CBE45"],
  ["BX22", "Bx22", "Bedford Park - Castle Hill", "EE352E"],
  ["BX23", "Bx23", "Pelham Bay - Co-Op City", "B933AD"],
  ["BX24", "Bx24", "Country Club - Hutchinson Metro Center", "6CBE45"],
  ["BX25", "Bx25", "Co-op City Bay Plaza - Bedford Park", "FAA61A"],
  ["BX26", "Bx26", "Co-op City Section 5 - Bedford Park", "FAA61A"],
  ["BX27", "Bx27", "Clasons Pt - Gladstone Sq", "00AEEF"],
  ["BX28", "Bx28", "Co-op City Section 5 - Fordham Center", "00AEEF"],
  ["BX29", "Bx29", "City Island - Pelham Bay", "00AEEF"],
  ["BX30", "Bx30", "Co-op City Section 5 - Pelham Parkway", "EE352E"],
  ["BX31", "Bx31", "Woodlawn - Westchester Sq", "EE352E"],
  ["BX32", "Bx32", "Kingsbridge VA Hospital - Mott Haven", "6CBE45"],
  ["BX33", "Bx33", "Port Morris - Harlem", "6CBE45"],
  ["BX34", "Bx34", "Woodlawn - Fordham Center", "B933AD"],
  ["BX35", "Bx35", "George Washington Bridge-West Farms Road", "00AEEF"],
  ["BX36", "Bx36", "Soundview - George Washington Bridge", "B933AD"],
  ["BX38", "Bx38", "Co-op City Bay Plaza - Norwood", "FAA61A"],
  ["BX39", "Bx39", "Wakefield - Clason Pt", "FAA61A"],
  ["BX40", "Bx40", "Throgs Neck - River Park Towers", "006CB7"],
  ["BX41", "Bx41", "Williamsbridge - The Hub", "EE352E"],
  ["BX41+", "Bx41-SBS", "Williamsbridge - The Hub", "EE352E"],
  ["BX42", "Bx42", "Throgs Neck - River Park Towers", "EE352E"],
  ["BX46", "Bx46", "Prospect Av - Westchester Av / Hunts Point Market", "EE352E"],
  ["BXM1", "BxM1", "Riverdale - East Midtown", "00933C"],
  ["BXM2", "BxM2", "Riverdale - West Midtown", "00933C"],
  ["BXM3", "BxM3", "Yonkers - Midtown", "00933C"],
  ["BXM4", "BxM4", "Woodlawn - Midtown", "00933C"],
  ["BXM6", "BxM6", "Parkchester - Midtown", "00933C"],
  ["BXM7", "BxM7", "Co-Op City - Midtown", "00933C"],
  ["BXM8", "BxM8", "Pelham Bay/City Island - Midtown", "00933C"],
  ["BXM9", "BxM9", "Throgs Neck - Midtown Express", "00933C"],
  ["BXM10", "BxM10", "Williamsbridge/Morris Park - Midtown", "00933C"],
  ["BXM11", "BxM11", "Wakefield - Midtown", "00933C"],
  ["BXM18", "BxM18", "Riverdale - Downtown", "00933C"],
  ["M1", "M1", "Harlem - East Village", "EE352E"],
  ["M2", "M2", "Washington Heights - East Village", "B933AD"],
  ["M3", "M3", "Fort George - East Village", "B933AD"],
  ["M4", "M4", "The Cloisters - 32 St", "00AEEF"],
  ["M5", "M5", "George Washington Bridge - 31 St & 6 Av", "EE352E"],
  ["M7", "M7", "Harlem - 14th Street", "00AEEF"],
  ["M8", "M8", "West Village - East Village", "00AEEF"],
  ["M9", "M9", "Battery Park City - Kips Bay", "B933AD"],
  ["M10", "M10", "Harlem - Columbus Circle", "006CB7"],
  ["M11", "M11", "Riverbank Park & Harlem - West Village", "FAA61A"],
  ["M12", "M12", "Midtown West - West Village", "006CB7"],
  ["M14A+", "M14A-SBS", "Lower East Side - Abingdon Sq", "6CBE45"],
  ["M14D+", "M14D-SBS", "Lower East Side - Chelsea Piers", "6CBE45"],
  ["M15", "M15", "East Harlem - South Ferry", "006CB7"],
  ["M15+", "M15-SBS", "East Harlem - South Ferry", "006CB7"],
  ["M20", "M20", "Lincoln Center - South Ferry", "EE352E"],
  ["M21", "M21", "Lower East Side - West Village", "FAA61A"],
  ["M22", "M22", "Lower East Side - Battery Park City", "00AEEF"],
  ["M23+", "M23-SBS", "Chelsea Piers - East Side", "B933AD"],
  ["M31", "M31", "Yorkville - Clinton", "B933AD"],
  ["M34+", "M34-SBS", "East Side - Javits Center", "006CB7"],
  ["M34A+", "M34A-SBS", "Waterside - Port Authority Terminal", "006CB7"],
  ["M35", "M35", "Ward's Island - East Harlem", "FAA61A"],
  ["M42", "M42", "United Nations - W 42 St Pier", "EE352E"],
  ["M50", "M50", "W 42 St Pier - East Side", "6CBE45"],
  ["M55", "M55", "W 44 St  - South Ferry", "6CBE45"],
  ["M57", "M57", "East Side - West Side", "00AEEF"],
  ["M60+", "M60-SBS", "West Side - LaGuardia Airport", "EE352E"],
  ["M66", "M66", "East Side - Lincoln Center", "FAA61A"],
  ["M72", "M72", "East Side - West Side", "6CBE45"],
  ["M79+", "M79-SBS", "Yorkville - West Side", "EE352E"],
  ["M86+", "M86-SBS", "Yorkville - West Side", "FAA61A"],
  ["M96", "M96", "East Side - West Side", "6CBE45"],
  ["M98", "M98", "Washington Heights - Upper East Side LTD", "EE352E"],
  ["M100", "M100", "Inwood - Harlem", "00AEEF"],
  ["M101", "M101", "East Village - Fort George", "FAA61A"],
  ["M102", "M102", "Harlem - East Village", "FAA61A"],
  ["M103", "M103", "East Harlem - City Hall", "B933AD"],
  ["M104", "M104", "West Harlem - Times Square", "B933AD"],
  ["M106", "M106", "East Harlem - West Side", "6CBE45"],
  ["M116", "M116", "West Side - East Harlem", "6CBE45"],
  ["M125", "M125", "Manhattanville - The Hub", "B933AD"],
  ["Q1", "Q1", "Bellerose - Jamaica", "FAA61A"],
  ["Q2", "Q2", "Queens Village - Jamaica", "6CBE45"],
  ["Q3", "Q3", "Jamaica - JFK Airport", "00AEEF"],
  ["Q4", "Q4", "Cambria Heights - Jamaica", "EE352E"],
  ["Q5", "Q5", "Laurelton - Jamaica", "EE352E"],
  ["Q06", "Q6", "Jamaica - Sutphin Blvd - Jfk Cargo Area", "EE352E"],
  ["Q07", "Q7", "Cypress Hills - Rockaway Blvd - Jfk Travel Plz.", "FAA61A"],
  ["Q08", "Q8", "Gateway Mall / East Ny - Jamaica", "EE352E"],
  ["Q09", "Q9", "Jamaica - South Ozone Park", "B933AD"],
  ["Q10", "Q10", "JFK Airtrain - Kew Gardens Via Rockaway", "FAA61A"],
  ["Q11", "Q11", "Howard Beach - Elmhurst", "6CBE45"],
  ["Q12", "Q12", "Little Neck - Flushing", "EE352E"],
  ["Q13", "Q13", "Fort Totten - Flushing", "EE352E"],
  ["Q14", "Q14", "East Elmhurst - Ridgewood", "00AEEF"],
  ["Q15", "Q15", "Flushing - Beechhurst", "FAA61A"],
  ["Q16", "Q16", "Fort Totten - Flushing", "EE352E"],
  ["Q17", "Q17", "Flushing - Jamaica", "EE352E"],
  ["Q18", "Q18", "Astoria - Maspeth", "FAA61A"],
  ["Q19", "Q19", "Flushing - Astoria", "FAA61A"],
  ["Q20", "Q20", "College Point - Jamaica", "FAA61A"],
  ["Q22", "Q22", "Rockaway Beach Bl / Beach Channel Dr", "EE352E"],
  ["Q23", "Q23", "East Elmhurst - Forest Hills", "FAA61A"],
  ["Q24", "Q24", "Bedford Stuyvesant - Jamaica", "00AEEF"],
  ["Q25", "Q25", "College Point - Jamaica", "FAA61A"],
  ["Q26", "Q26", "College Point - Fresh Meadows", "FAA61A"],
  ["Q27", "Q27", "Cambria Heights - Flushing", "EE352E"],
  ["Q28", "Q28", "Flushing - Bay Terrace Rush", "B933AD"],
  ["Q29", "Q29", "Elmhurst - Glendale", "FAA61A"],
  ["Q30", "Q30", "Little Neck - Jamaica", "FAA61A"],
  ["Q31", "Q31", "Bayside - Jamaica", "FAA61A"],
  ["Q32", "Q32", "Jackson Heights - Penn Station (Midtown)", "FAA61A"],
  ["Q33", "Q33", "Marine Air Terminal Lga-Jackson Heights", "FAA61A"],
  ["Q35", "Q35", "Rockaway Park - Midwood / Brooklyn Coll.", "006CB7"],
  ["Q36", "Q36", "Little Neck - Jamaica", "FAA61A"],
  ["Q37", "Q37", "Kew Gardens - South Ozone Park", "00AEEF"],
  ["Q38", "Q38", "Rego Park - Maspeth", "FAA61A"],
  ["Q39", "Q39", "Long Island City - Glendale", "FAA61A"],
  ["Q40", "Q40", "South Ozone Park - Jamaica", "B933AD"],
  ["Q41", "Q41", "Jamaica - Howard Beach", "FAA61A"],
  ["Q42", "Q42", "Addisleigh Park - Jamaica", "00AEEF"],
  ["Q43", "Q43", "Floral Park - Jamaica", "EE352E"],
  ["Q44+", "Q44-SBS", "Bronx Zoo - Jamaica", "EE352E"],
  ["Q45", "Q45", "Fresh Meadows - Kew Gardens", "EE352E"],
  ["Q46", "Q46", "LIJ Hospital - Kew Gardens", "EE352E"],
  ["Q47", "Q47", "East Elmhurst - Glendale", "FAA61A"],
  ["Q48", "Q48", "Glen Oaks - Kew Gardens", "006CB7"],
  ["Q49", "Q49", "East Elmhurst - Jackson Heights", "FAA61A"],
  ["Q50", "Q50", "Co-Op City/Pelham Bay - Flushing Ltd", "EE352E"],
  ["Q51", "Q51", "Linden Blvd Limited", "EE352E"],
  ["Q52+", "Q52-SBS", "Elmhurst - Arverne Sbs Vis Woodhaven/Cross Bay", "006CB7"],
  ["Q53+", "Q53-SBS", "Woodside - Rockaway Park", "006CB7"],
  ["Q54", "Q54", "Williamsburg - Jamaica", "B933AD"],
  ["Q55", "Q55", "Ridgewood - Richmond Hill", "EE352E"],
  ["Q56", "Q56", "Broadway Junction - Jamaica", "B933AD"],
  ["Q58", "Q58", "Ridgewood - Flushing", "6CBE45"],
  ["Q59", "Q59", "Williamsburg - Rego Park", "FAA61A"],
  ["Q60", "Q60", "Queens Blvd. - East Midtown", "FAA61A"],
  ["Q61", "Q61", "Beechhurst - Flushing", "B933AD"],
  ["Q63", "Q63", "Flushing - Long Island City Rush", "B933AD"],
  ["Q64", "Q64", "Electchester - Forest Hills", "FAA61A"],
  ["Q65", "Q65", "Flushing - Jamaica", "FAA61A"],
  ["Q66", "Q66", "Flushing - Long Island City", "FAA61A"],
  ["Q67", "Q67", "Long Island City - Maspeth", "FAA61A"],
  ["Q69", "Q69", "East Elmhurst - Long Island City", "FAA61A"],
  ["Q70+", "Q70-SBS", "LaGuardia Link", "006CB7"],
  ["Q72", "Q72", "LaGuardia Airport - Rego Park", "FAA61A"],
  ["Q74", "Q74", "Forest Hills - Qcc Ltd", "EE352E"],
  ["Q75", "Q75", "Jamaica - QCC", "00AEEF"],
  ["Q76", "Q76", "College Point - Jamaica", "6CBE45"],
  ["Q77", "Q77", "Springfield Gardens - Jamaica", "FAA61A"],
  ["Q80", "Q80", "Jfk Airtrain - Kew Gardens Via Lefferts", "EE352E"],
  ["Q82", "Q82", "Jamaica - Belmont Park", "FAA61A"],
  ["Q83", "Q83", "Cambria Heights - Jamaica", "6CBE45"],
  ["Q84", "Q84", "Laurelton - Jamaica", "B933AD"],
  ["Q85", "Q85", "Rosedale - Jamaica", "EE352E"],
  ["Q86", "Q86", "Rosedale - Jamaica", "B933AD"],
  ["Q87", "Q87", "Green Acres - Jamaica", "B933AD"],
  ["Q88", "Q88", "Elmhurst - Queens Village", "FAA61A"],
  ["Q89", "Q89", "Green Acres - Jamaica", "B933AD"],
  ["Q90", "Q90", "Flushing - LaGuardia Airport", "EE352E"],
  ["Q98", "Q98", "Ridgewood - Flushing", "6CBE45"],
  ["Q100", "Q100", "Rikers Island - Long Island City Ltd", "EE352E"],
  ["Q101", "Q101", "Steinway - Hunters Point", "FAA61A"],
  ["Q102", "Q102", "Roosevelt Island - Long Island City", "FAA61A"],
  ["Q103", "Q103", "Astoria - Hunters Point", "FAA61A"],
  ["Q104", "Q104", "Astoria - Sunnyside", "FAA61A"],
  ["Q110", "Q110", "Jamaica Avenue East", "FAA61A"],
  ["Q111", "Q111", "Rosedale - Jamaica Rush", "B933AD"],
  ["Q112", "Q112", "Jamaica - East Ny", "EE352E"],
  ["Q113", "Q113", "Far Rockaway - Jamaica Limited", "EE352E"],
  ["Q114", "Q114", "Far Rockaway - Jamaica Rush", "B933AD"],
  ["Q115", "Q115", "Brewer Blvd. Local", "EE352E"],
  ["QM1", "QM1", "Fresh Meadows - Midtown Express", "00933C"],
  ["QM2", "QM2", "Bay Terrace - Midtown Express", "00933C"],
  ["QM4", "QM4", "Electchester - Midtown Express", "00933C"],
  ["QM5", "QM5", "Glen Oaks - Midtown Express", "00933C"],
  ["QM6", "QM6", "Lake Success - Midtown Express", "00933C"],
  ["QM7", "QM7", "Fresh Meadows - Downtown Express", "00933C"],
  ["QM8", "QM8", "Glen Oaks - Downtown Express", "00933C"],
  ["QM10", "QM10", "Lefrak City - Midtown Express", "00933C"],
  ["QM11", "QM11", "Forest Hills - Downtown Express", "00933C"],
  ["QM12", "QM12", "Forest Hills - Midtown Express", "00933C"],
  ["QM15", "QM15", "Lindenwood - Midtown Express", "00933C"],
  ["QM16", "QM16", "Neponsit - Midtown Express", "00933C"],
  ["QM17", "QM17", "Far Rockaway - Midtown Express", "00933C"],
  ["QM18", "QM18", "South Ozone Park - Midtown Express", "00933C"],
  ["QM20", "QM20", "Bay Terrace - Midtown Express", "00933C"],
  ["QM21", "QM21", "Rochdale Village - Midtown Exp.", "00933C"],
  ["QM24", "QM24", "Glendale - Midtown Express", "00933C"],
  ["QM25", "QM25", "Glendale - Downtown Express", "00933C"],
  ["QM31", "QM31", "Fresh Meadows - Midtown Express", "00933C"],
  ["QM32", "QM32", "Bay Terrace - Midtown Express", "00933C"],
  ["QM34", "QM34", "Glendale - Midtown Express", "00933C"],
  ["QM35", "QM35", "Glen Oaks - Midtown Express", "00933C"],
  ["QM36", "QM36", "Lake Success - Midtown Express", "00933C"],
  ["QM40", "QM40", "Lefrak City - Midtown Express", "00933C"],
  ["QM42", "QM42", "Forest Hills - Midtown Express", "00933C"],
  ["QM44", "QM44", "Electchester - Midtown Express", "00933C"],
  ["QM63", "QM63", "Rosedale - Midtown Express", "00933C"],
  ["QM64", "QM64", "Elmont - Midtown Express", "00933C"],
  ["QM65", "QM65", "Laurelton-Rochdale-Lower Manhattan", "00933C"],
  ["QM68", "QM68", "Floral Park - Midtown Express", "00933C"],
  ["S40", "S40", "St. George - Amazon", "B933AD"],
  ["S42", "S42", "St. George - Clyde Place", "00AEEF"],
  ["S44", "S44", "St. George - Staten Island Mall", "FAA61A"],
  ["S46", "S46", "St. George - West Shore Plaza", "006CB7"],
  ["S48", "S48", "St. George - Mariners Harbor", "EE352E"],
  ["S51", "S51", "St. George - Grant City", "006CB7"],
  ["S52", "S52", "St. George - Staten Island Univ. Hospital", "B933AD"],
  ["S53", "S53", "Port Richmond - Bay Ridge", "EE352E"],
  ["S54", "S54", "West New Brighton - Eltingville", "FAA61A"],
  ["S55", "S55", "Rossville - Staten Island Mall", "FAA61A"],
  ["S56", "S56", "Huguenot - Staten Island Mall", "6CBE45"],
  ["S57", "S57", "Port Richmond - New Dorp", "6CBE45"],
  ["S59", "S59", "Port Richmond - Tottenville", "EE352E"],
  ["S61", "S61", "St. George - Staten Island Mall", "EE352E"],
  ["S62", "S62", "St. George - Travis", "B933AD"],
  ["S66", "S66", "St. George - Port Richmond", "6CBE45"],
  ["S74", "S74", "St. George - Bricktown Mall", "EE352E"],
  ["S76", "S76", "St. George - Oakwood", "B933AD"],
  ["S78", "S78", "St. George - Bricktown Mall", "FAA61A"],
  ["S79+", "S79-SBS", "Staten Island Mall - Bay Ridge", "006CB7"],
  ["S81", "S81", "St. George - Grant City LTD", "006CB7"],
  ["S84", "S84", "St. George - Bricktown Mall LTD", "EE352E"],
  ["S86", "S86", "St. George - Oakwood LTD", "B933AD"],
  ["S89", "S89", "Eltingville - Bayonne LTD", "EE352E"],
  ["S90", "S90", "St. George - Amazon", "B933AD"],
  ["S91", "S91", "St. George - Staten Island Mall LTD", "EE352E"],
  ["S92", "S92", "St. George - Travis LTD", "B933AD"],
  ["S93", "S93", "College of Staten Island - Bay Ridge LTD", "EE352E"],
  ["S94", "S94", "St. George - Staten Island Mall LTD", "FAA61A"],
  ["S96", "S96", "St. George - West Shore Plaza LTD", "006CB7"],
  ["S98", "S98", "St. George - Mariners Harbor LTD", "EE352E"],
  ["SIM1", "SIM1", "Eltingville - Lower Manhattan Express", "00933C"],
  ["SIM1C", "SIM1C", "Eltingville - Manhattan Express", "00933C"],
  ["SIM2", "SIM2", "Tottenville - Lower Manhattan Express", "00933C"],
  ["SIM3", "SIM3", "Pt. Richmond - Midtown Manhattan Express", "00933C"],
  ["SIM3C", "SIM3C", "Pt. Richmond - Manhattan Express", "00933C"],
  ["SIM4", "SIM4", "Eltingville - Lower Manhattan Express", "00933C"],
  ["SIM4C", "SIM4C", "Huguenot - Manhattan Express", "00933C"],
  ["SIM5", "SIM5", "Eltingville - Lower Manhattan Express", "00933C"],
  ["SIM6", "SIM6", "Eltingville - Midtown Manhattan Express", "00933C"],
  ["SIM7", "SIM7", "Eltingville - Greenwich Village Express", "00933C"],
  ["SIM8", "SIM8", "Huguenot - Midtown Manhattan Express", "00933C"],
  ["SIM9", "SIM9", "Eltingville - Greenwich Village Express", "00933C"],
  ["SIM10", "SIM10", "Eltingville - Midtown Manhattan Express", "00933C"],
  ["SIM11", "SIM11", "New Dorp - Midtown Manhattan Express", "00933C"],
  ["SIM15", "SIM15", "Eltingville - Lower Manhattan Express", "00933C"],
  ["SIM22", "SIM22", "Eltingville - Midtown Manhattan Express", "00933C"],
  ["SIM23", "SIM23", "Annadale - Midtown Manhattan Express", "00933C"],
  ["SIM24", "SIM24", "Prince's Bay - Midtown Manhattan Express", "00933C"],
  ["SIM25", "SIM25", "Tottenville - Midtown Manhattan Express", "00933C"],
  ["SIM26", "SIM26", "Tottenville - Midtown Manhattan Express", "00933C"],
  ["SIM30", "SIM30", "Sunnyside - Midtown Manhattan Express", "00933C"],
  ["SIM31", "SIM31", "Eltingville - Midtown Manhattan Express", "00933C"],
  ["SIM32", "SIM32", "Travis - Lower Manhattan Express", "00933C"],
  ["SIM33", "SIM33", "Mariners Harbor - Manhattan Express", "00933C"],
  ["SIM33C", "SIM33C", "Mariners Harbor - Greenwich Village Express", "00933C"],
  ["SIM34", "SIM34", "Mariners Harbor - Lower Manhattan Express", "00933C"],
  ["SIM35", "SIM35", "Port Richmond - Lower Manhattan Express", "00933C"],
  ["X27", "X27", "Bay Ridge - Manhattan Express", "00933C"],
  ["X28", "X28", "Sea Gate / Bensonhurst - Manhattan Express", "00933C"],
  ["X37", "X37", "Bay Ridge - Midtown Manhattan Express", "00933C"],
  ["X38", "X38", "Sea Gate / Bensonhurst - Midtown Manhattan Express", "00933C"]
]
